import { request } from '@/service/request';

import type { MenuItemDto } from './menu';

export function getInfo() {
  return request({
    method: 'get',
    url: '/platform/getAdminInfoByToken'
  });
}

interface MenusDto {
  menuList: MenuItemDto[];
  permissionsList: string[];
}
export function getMenus() {
  return request<MenusDto>({
    method: 'get',
    url: '/platform/getMenus'
  });
}
